import type { Ref } from "react";
import { ArrowRight, FileSearch } from "lucide-react";
import { Button } from "../ui/button";

export type RescueGuideView = "evidence" | "plan" | "investigation";

type Props = {
  view: RescueGuideView | null;
  onChoose: (view: RescueGuideView) => void;
  planChoiceRef?: Ref<HTMLButtonElement>;
};

export function RescueGuideChoices({ view, onChoose, planChoiceRef }: Props) {
  return (
    <div className="mt-6 flex flex-wrap items-center gap-3">
      <Button
        type="button"
        className="h-auto min-h-11 max-w-full whitespace-normal bg-orange-700 text-white hover:bg-orange-800"
        aria-expanded={view === "investigation"}
        aria-controls="rescue-investigation-answer"
        onClick={() => onChoose("investigation")}
      >
        Investigate this case
      </Button>
      <Button
        ref={planChoiceRef}
        type="button"
        variant="outline"
        className="h-auto min-h-11 max-w-full gap-3 whitespace-normal px-5"
        aria-expanded={view === "plan"}
        aria-controls="rescue-plan-answer"
        onClick={() => onChoose("plan")}
      >
        Review recovery plan
        <ArrowRight className="h-4 w-4 shrink-0" aria-hidden="true" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        className="h-auto min-h-11 max-w-full whitespace-normal text-muted-foreground hover:text-foreground"
        aria-expanded={view === "evidence"}
        aria-controls="rescue-evidence-answer"
        onClick={() => onChoose("evidence")}
      >
        <FileSearch className="h-4 w-4 shrink-0" aria-hidden="true" />
        Review evidence
      </Button>
    </div>
  );
}
